import React from 'react';
import GameRoomPlayer from './GameRoomPlayer';
import { GameRoomPlayersInterface } from './GameRoomPlayersInterface';
import { getScore } from '../utils/ScoresUtils';

function GameRoomFourPlayers({players, currentRound, roundBlackCards, roundPhase, scoresMap, shouldShowHand}: GameRoomPlayersInterface) {

    return (
        <div className="playersWrapper">
            <div className="fourPlayersWrapper1">
                <GameRoomPlayer player={players[3]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[3].id)} shouldShowHand={shouldShowHand} />
            </div>
            <div className="fourPlayersWrapper2">
                <GameRoomPlayer player={players[1]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[1].id)} shouldShowHand={shouldShowHand} />
                <GameRoomPlayer player={players[2]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[2].id)} shouldShowHand={shouldShowHand} />
            </div>
            <div className="fourPlayersWrapper3">
                <GameRoomPlayer player={players[0]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[0].id)} shouldShowHand={shouldShowHand} />
            </div>
        </div>
    );
};

export default GameRoomFourPlayers;